import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SubscriptionComponent } from './subscription.component';
import { FormsModule }   from '@angular/forms';
import {PaymentModule} from "../payment/payment.module";
import { SharedModule } from '../shared/shared.module';

@NgModule({
    imports: [CommonModule, FormsModule, PaymentModule, SharedModule],
    declarations: [SubscriptionComponent],
    exports: [SubscriptionComponent]
})

export class SubscriptionModule { }
